import { render, staticRenderFns } from "./EventCrewSelect.vue?vue&type=template&id=486e1412"
import script from "./EventCrewSelect.vue?vue&type=script&lang=js"
export * from "./EventCrewSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports